import { apiClient, APIResponse, extractApiError, buildQuery } from './api';

export const categoryBudgetsAPI = {
  async list(params) {
    try {
      const { data } = await apiClient.get(`/category-budgets/${buildQuery(params)}`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar os orçamentos.'),
      );
    }
  },

  async upsert({
    categoryId,
    year,
    month,
    amount,
    notes = '',
    periodStart,
    periodEnd,
  }) {
    try {
      const { data } = await apiClient.post('/category-budgets/', {
        category: categoryId,
        reference_year: year,
        reference_month: month,
        amount,
        notes,
        ...(periodStart && periodEnd
          ? { period_start: periodStart, period_end: periodEnd }
          : {}),
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível guardar o orçamento.'),
      );
    }
  },

  async remove(id) {
    try {
      await apiClient.delete(`/category-budgets/${id}/`);
      return APIResponse.success(null);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível remover o orçamento.'),
      );
    }
  },

  async getCategoryStatus(categoryId, { year, month }) {
    try {
      const { data } = await apiClient.get(
        `/categories/${categoryId}/budget-status/${buildQuery({ year, month })}`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o estado do orçamento.'),
      );
    }
  },

  async getCategoryHistory(categoryId, { year, month } = {}) {
    try {
      const { data } = await apiClient.get(
        `/categories/${categoryId}/budget-history/${buildQuery({ year, month })}`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o histórico.'),
      );
    }
  },
};
